import { callApi } from './api'
import { USER } from './schemas'

export function fetch (id) {
  const endpoint = `users/${id}`
  const config = {
    requiresAuth: true
  }
  return callApi(endpoint, config, USER)
}

export function fetchNextServices (id) {
  const endpoint = `users/${id}/services/next`
  const config = {
    requiresAuth: true
  }
  return callApi(endpoint, config)
}



// WEBPACK FOOTER //
// ./src/services/api/users.js